<template>
  <div class="predefine" dir="rtl">
    <div class="">
      <div
        ref="form"
      >
        <div class="predefine-card" >

          <div v-for="item in pre_defined_items">

            <v-row class="checkbox-row">
              <v-col v-if="item.PredefineTypeId == 1">
                <label>{{item.Text}}</label>

              </v-col>

              <v-col v-if="item.PredefineTypeId == 1">
                <v-checkbox
                  v-model="item.IsChecked"
                  :value="item.IsChecked"
                />
              </v-col>

              <v-col v-if="item.PredefineTypeId == 2">
                <v-text-field
                  v-if="item.PredefineTypeId == 2"
                  v-model="item.Value"
                  :label="item.Text"
                  value="false"
                  outlined
                />
              </v-col>

            </v-row>

          </div>

        </div>
        <v-row>

          <v-btn color="primary" style="border-radius: 0px;" class="enter-btn"  v-on:click="go_to_details()">{{ $t('add_information') }}</v-btn>

        </v-row>
        <div>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        price: '',
        branch_id: 0,
        // device_serial_number: '',
        device_password: '',
        pre_defined_items: [],

        valid: true,
        not_register: false,
        user_registered: false,

      }
    },
watch: {

    },
mounted () {
this.get_request_info()
    },
    methods: {
      get_request_info() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: user_id,
          RequestId: this.$route.params.rec_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetRequestInfoByReqId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.request_info = response.data.rec

              self.get_predifined()

            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

      go_to_details () {
        let text_pre ="";
        const yourlist_type1 = this.pre_defined_items.filter(x => x.PredefineTypeId == 1);
        const yourlist_type2 = this.pre_defined_items.filter(x => x.PredefineTypeId == 2);
        const yourlist_type3 = this.pre_defined_items.filter(x => x.PredefineTypeId == 3);
        const yourlist_type4 = this.pre_defined_items.filter(x => x.PredefineTypeId == 4);

        for (var i = 0; i < yourlist_type1.length; i++) {

          if(yourlist_type1[i].IsChecked){
            text_pre+=(yourlist_type1[i].Text)+("\n");
          }

        }
        for (var i = 0; i < yourlist_type2.length; i++) {

          if(yourlist_type2[i].Value!="" && yourlist_type2[i].Value!=null){
            text_pre+=(yourlist_type2[i].Text)+(" : ")+(yourlist_type2[i].Value)+("\n");
          }

        }

        for (var i = 0; i < yourlist_type3.length; i++) {

          if(yourlist_type3[i].Value!=""){
            text_pre+=(yourlist_type3[i].Text)+(" : ")+(yourlist_type3[i].Value)+("\n");
          }
        }
        this.change_tech_status(text_pre)
      },


      get_predifined () {
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var user_id = this.request_info.UserId
        var typeId = this.request_info.PType
        var catId = this.request_info.PCat
        var subcatId = this.request_info.PGrp
        var brandId = this.request_info.PSubGrp
        var DeviceModel = ""

        const send_data = {
          TypeId: typeId,
          CatId: catId,
          GroupId: subcatId,
          BrandId: brandId,
          Model: DeviceModel,
          Phone: DeviceModel,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/PredefinedText', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
self.pre_defined_items = response.data.PredefinedList
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      change_tech_status(summary) {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          StatusId: 105,
          Desc: summary,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddChangeStatusByTech', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])
            self.change_status_dialog = false;
            self.get_request_info()
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

  }
  }
</script>
